import React from 'react';
import { string, func, arrayOf, shape } from 'prop-types';
import RequirementItem from './requirement-item/index';

import styles from './requirements.scss';

const RequirementsModalLayout = ({ requirements }) => (
  <div
    data-hook="mi-facebook-catalog-requirements"
    className={styles.container}
  >
    {requirements.map(({ titleKey, linkLabel, link }, index, array) => {
      const reqItem = (
        <RequirementItem
          key={titleKey}
          titleKey={titleKey}
          linkLabel={linkLabel}
          link={link}
        />
      );
      if (array.length - 1 === index) {
        return reqItem;
      }
      return (
        <div key={titleKey}>
          {reqItem}
          <div className={styles.separator} />
        </div>
      );
    })}
  </div>
);

RequirementsModalLayout.propTypes = {
  titleKey: string,
  t: func,
  onClose: func,
  requirements: arrayOf(
    shape({
      titleKey: string.isRequired,
      linkLabel: string.isRequired,
      link: string.isRequired,
    }),
  ).isRequired,
};

export default RequirementsModalLayout;
